import * as React from 'react';
import authenticationService from '../authentication';

export interface Auth0HandleRedirectComponentProps {
    history: any;
}

export default class Auth0HandleRedirectComponent extends React.Component<
    Auth0HandleRedirectComponentProps
> {
    constructor(props: Auth0HandleRedirectComponentProps) {
        super(props);

        authenticationService.handleRedirectCallback().then(() => {
            const urlParams = new URLSearchParams(window.location.search);
            const targetPath = urlParams.get('targetPath');

            // Rebuild the original Query
            urlParams.delete('targetPath');
            urlParams.delete('code');
            urlParams.delete('state');
            const urlParamsToString = urlParams.toString();

            if (targetPath) {
                this.props.history.replace(
                    `${targetPath}?${urlParamsToString}`,
                );
            } else {
                this.props.history.replace(`/`);
            }
        });
    }

    render(): string {
        return '';
    }
}
